import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../services/user.service';

@Injectable({ providedIn: 'root' })
export class WorkerGuard {
  private readonly router = inject(Router);
  private readonly user_service = inject(UserService);

  canActivate(): boolean {
    const user = this.user_service.getCurrentUser();
    if (user?.role?.slug === 'worker') {
      return true;
    }

    this.router.navigate(['/']);
    return false;
  }
}
